import React from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';

import { content, theme } from '../../tailwind.config.js';

const localWindow = typeof window !== 'undefined' ? window : { innerWidth: 0 };

export const useIsMobile = () => {
  const [width, setWidth] = React.useState(localWindow.innerWidth);
  //https://github.com/tailwindlabs/tailwindcss/issues/6422#issuecomment-1222368084
  const fullConfig = resolveConfig({ content, theme }) as any;

  const mobileBreakpoint = parseInt(
    fullConfig.theme?.screens.lg?.replace('px', ''),
    10,
  );

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(localWindow?.innerWidth ?? 0);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  //If this hook runs in SSR, always return true, allowing pages to render mobile view first
  //This will lead to hydration errors on desktop, but better initial performance on mobile
  //LightHous performance scores: 99 for Desktop and 85-89 for Mobile.

  return localWindow ? width < mobileBreakpoint : true;
};
